import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "OptOutDialog", webpackPrefetch: true */ './lazyIndex')
);

export let lazyShowOptOutDialog = new LazyAction(lazyModule, m => m.showOptOutDialog);
